import React, { useEffect, useState } from "react";

import type { ItemType, VariantType } from "@shared/graphql.types";

import { confirmationWrapper, fadeEffectBottom } from "./ATBConfirmation.css";
import { SimpleProductCardWrapper } from "../ProductCard/SimpleProductCard/SimpleProductCardWrapper";
import { ExpanderButton } from "../ExpanderButton/ExpanderButton";

type ATBConfirmationProductsProps = {
  variants: VariantType[];
  inLimitItems: ItemType[];
};

export const ATBConfirmationProducts: React.FC<
  ATBConfirmationProductsProps
> = ({ variants, inLimitItems }): JSX.Element => {
  const divRef = React.createRef<HTMLDivElement>();

  const showExpander = variants.length > 3;

  const [showMore, setShowMore] = useState(showExpander);
  const [hasOverflow, setHasOverflow] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  useEffect(() => {
    if (divRef?.current) {
      const { offsetHeight, scrollHeight, offsetWidth, scrollWidth } =
        divRef.current;
      if (
        showExpander &&
        (offsetHeight < scrollHeight || offsetWidth < scrollWidth)
      ) {
        setHasOverflow(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divRef]);

  if (!variants) {
    return <></>;
  }

  return (
    <div
      ref={divRef}
      data-testid="multi-product-cards"
      style={{ maxHeight: showMore ? "18rem" : "max-content" }}
      className={showMore ? fadeEffectBottom : confirmationWrapper}
    >
      {variants.map((productVariant) => {
        const currentProductVariant = inLimitItems.find(
          (item) =>
            item.type === "product" && item?.variant?.id === productVariant?.id
        );

        if (currentProductVariant) {
          return (
            <SimpleProductCardWrapper
              key={currentProductVariant.id}
              item={currentProductVariant}
            />
          );
        }

        return null;
      })}

      {hasOverflow && (
        <ExpanderButton toggleShowMore={toggleShowMore} showMore={showMore} />
      )}
    </div>
  );
};
